import {
  KdsCardUserActivity,
  type KdsCommentProps,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { useAtomValue } from "jotai";

import { getHumainDurationFromNow } from "@/helpers/dates/getHumainDurationFromNow";
import { getUserFullName } from "@/helpers/getUserFullName";
import { userAtom } from "@/store";
import { type TransitionData } from "@/types/transitionData";
import { OrderItemPageActivityLogMessage } from "../OrderItemPageActivityLogMessage";
import { type OrderItemPageActivityLogFilesProps } from "./OrderItemPageActivityLogFiles.types";

export const OrderItemPageActivityLogFiles = ({
  orderItemLog,
  handleSubmitComment,
}: OrderItemPageActivityLogFilesProps) => {
  const { t } = useTranslate();
  const userAtomValue = useAtomValue(userAtom);

  const transitionData = orderItemLog.transitionData as TransitionData;
  const files = transitionData?.files;
  const associatedOrderItems = transitionData?.relatedOrderItemsIds;

  return (
    files?.length &&
    files?.map((file, index: number) => (
      <KdsCardUserActivity
        key={file.blobId || index}
        avatarProps={{
          type: "image",
          name: `${orderItemLog.user?.firstname} ${orderItemLog.user?.lastname}`,
        }}
        chatAreaProps={{
          maxLength: 300,
          placeholder: t(
            "order.myOrdersItemDetails.activityFeed.action.chatArea.placeholder"
          ),
          onSubmit: handleSubmitComment,
        }}
        comments={[
          ...orderItemLog.comments.map((comment) => {
            return {
              date: dayjs(comment.createdAt).fromNow(),
              comment: comment.content,
              userName: getUserFullName({
                firstname: comment.User?.firstname,
                lastname: comment.User?.lastname,
              }),
              avatarProps: {
                type: "image",
                name: getUserFullName({
                  firstname: comment.User?.firstname,
                  lastname: comment.User?.lastname,
                }),
              },
            } satisfies KdsCommentProps;
          }),
        ]}
        HeaderReactNode={
          <OrderItemPageActivityLogMessage
            orderItemLog={orderItemLog}
            associatedOrderItemsLength={associatedOrderItems?.length}
          />
        }
        timePassedAfterSendingComment={getHumainDurationFromNow(
          new Date(orderItemLog.createdAt),
          userAtomValue?.lang
        )}
      />
    ))
  );
};
